import React from 'react';
import { Logo } from '@/assets/logo';

interface SubmissionSuccessProps {
  type: 'add' | 'info';
}

export function SubmissionSuccess({ type }: SubmissionSuccessProps) {
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-4">
      <Logo className="h-12 w-12 text-primary mb-4" />
      <h1 className="text-xl font-semibold text-primary-dark mb-2">
        {type === 'add' ? 'تم تقديم الطلب' : 'تم إضافة المعلومات'}
      </h1>
      <p className="text-gray-600">
        {type === 'add' 
          ? 'تم تقديم طلبك بنجاح. سنراجعه ونعود إليك قريباً.'
          : 'تم إضافة معلوماتك بنجاح.'}
      </p>
    </div>
  );
}